import { ReactNode } from 'react';

import CheckBox from '@app/components/CheckBox';

import './AgreementCheck.scss';

interface AgreementCheckProps {
  id: string;
  checked: boolean;
  children: ReactNode;
  testId: string;
  onClick: () => void;
}

const defaultProps = {
  checked: false,
  children: null,
  testId: null,
  onClick() {},
};

function AgreementCheck({ checked, children, id, testId, onClick }: AgreementCheckProps) {
  return (
    <div className="AgreementCheck__agreement align-left">
      <CheckBox
        className="AgreementCheck__agreement-checkbox"
        id={id}
        isChecked={checked}
        testId={testId}
        onClick={onClick}
      />
      <label className="AgreementCheck__checkbox-label" htmlFor={id}>
        <div className="AgreementCheck__agreement-text">{children}</div>
      </label>
    </div>
  );
}

AgreementCheck.defaultProps = defaultProps;

export default AgreementCheck;
